var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEosMain100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 387 263.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{opacity:0.2;mix-blend-mode:multiply;}.cls-4{fill:#fff;}.cls-5{fill:url(#linear-gradient-2);}.cls-6{font-size:14px;fill:#5d665d;font-family:Roboto-Medium, Roboto;font-weight:500;}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 98.57,
    y1: 131.68,
    x2: 275.24,
    y2: 131.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92fe9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 40.91,
    y1: 88.36,
    x2: 67.09,
    y2: 88.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 293.91,
    y1: 46.36,
    x2: 320.09,
    y2: 46.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 319.91,
    y1: 163.36,
    x2: 346.09,
    y2: 163.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 65.91,
    y1: 205.36,
    x2: 92.09,
    y2: 205.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 108,
    height: 78,
    xlinkHref: "data:image/png;base64,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"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EOS Main100") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.9,0l-62,85L98.57,210.14l88.33,53.22,88.34-53.22L248.9,84.5ZM139.17,87.24,186.9,22l47.74,65.29L186.9,230.44Zm102.05,21.4L261,204.11l-64.74,38.95ZM112.83,204.11l19.75-95.47,45,134.42Z"
  }), /*#__PURE__*/React.createElement("use", {
    className: "cls-3",
    transform: "translate(0 59.36)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15,
    y: 74.36,
    width: 78,
    height: 48,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67,81.4a1,1,0,0,0-.23-.33s0,0,0,0l0,0a1.19,1.19,0,0,0-.33-.22,1.25,1.25,0,0,0-.42-.08H59.45a1.09,1.09,0,1,0,0,2.18h3.92l-7.73,7.73L51,86a1.08,1.08,0,0,0-1.54,0l-8.18,8.18a1.09,1.09,0,1,0,1.54,1.54l7.41-7.41L54.87,93a1.08,1.08,0,0,0,1.54,0l8.5-8.5v3.91a1.09,1.09,0,1,0,2.18,0V81.82A1.2,1.2,0,0,0,67,81.4Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(36.36 111.86)"
  }, "+12%"), /*#__PURE__*/React.createElement("use", {
    className: "cls-3",
    transform: "translate(253 17.36)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 268,
    y: 32.36,
    width: 78,
    height: 48,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M320,39.4a1,1,0,0,0-.23-.33s0,0,0,0l0,0a1.19,1.19,0,0,0-.33-.22,1.25,1.25,0,0,0-.42-.08h-6.55a1.09,1.09,0,1,0,0,2.18h3.92l-7.73,7.73L304,44a1.08,1.08,0,0,0-1.54,0l-8.18,8.18a1.09,1.09,0,1,0,1.54,1.54l7.41-7.41L307.87,51a1.08,1.08,0,0,0,1.54,0l8.5-8.5v3.91a1.09,1.09,0,1,0,2.18,0V39.82A1.2,1.2,0,0,0,320,39.4Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(289.36 69.86)"
  }, "+20%"), /*#__PURE__*/React.createElement("use", {
    className: "cls-3",
    transform: "translate(279 134.36)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 294,
    y: 149.36,
    width: 78,
    height: 48,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M346,156.4a1,1,0,0,0-.23-.33s0,0,0,0,0,0,0,0a1.19,1.19,0,0,0-.33-.22,1.25,1.25,0,0,0-.42-.08h-6.55a1.09,1.09,0,1,0,0,2.18h3.92l-7.73,7.73L330,161a1.08,1.08,0,0,0-1.54,0l-8.18,8.18a1.09,1.09,0,1,0,1.54,1.54l7.41-7.41,4.69,4.68a1.08,1.08,0,0,0,1.54,0l8.5-8.5v3.91a1.09,1.09,0,0,0,2.18,0v-6.54A1.2,1.2,0,0,0,346,156.4Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(315.36 186.86)"
  }, "+50%"), /*#__PURE__*/React.createElement("use", {
    className: "cls-3",
    transform: "translate(25 176.36)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 40,
    y: 191.36,
    width: 78,
    height: 48,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M92,198.4a1,1,0,0,0-.23-.33s0,0,0,0,0,0,0,0a1.19,1.19,0,0,0-.33-.22,1.25,1.25,0,0,0-.42-.08H84.45a1.09,1.09,0,0,0,0,2.18h3.92l-7.73,7.73L76,203a1.08,1.08,0,0,0-1.54,0l-8.18,8.18a1.09,1.09,0,1,0,1.54,1.54l7.41-7.41L79.87,210a1.08,1.08,0,0,0,1.54,0l8.5-8.5v3.91a1.09,1.09,0,1,0,2.18,0v-6.54A1.2,1.2,0,0,0,92,198.4Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(61.36 228.86)"
  }, "+18%"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEosMain100);
export default __webpack_public_path__ + "static/media/EOS-Main100.277758f11e8fe53a27fff55a4809b9c7.svg";
export { ForwardRef as ReactComponent };